import { NativeSelectField, NativeSelectRoot, NativeSelectFieldProps } from '@chakra-ui/react';
import { FC } from 'react';

type Props = NativeSelectFieldProps & {
  options: {
    name: string;
    value: string;
  }[];
};

export const Select: FC<Props> = ({ options, ...rest }) => {
  return (
    <NativeSelectRoot>
      <NativeSelectField {...rest}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.name}
          </option>
        ))}
      </NativeSelectField>
    </NativeSelectRoot>
  );
};
